import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { IonRouterOutlet } from "@ionic/react";

import { FiltrosReclamos, ReclamosConFiltroProps } from "src/utils/interfaces";

import ReclamosFiltros from "src/pages/ReclamosFiltros";
import ReclamosDeTrabajo from "src/pages/ReclamosDeTrabajo";

import Menu from "src/components/Menu";

const ReclamosConFiltro: React.FC<ReclamosConFiltroProps> = (
  props: ReclamosConFiltroProps
) => {
  const [filtros, setFiltros] = useState<FiltrosReclamos>({});

  const handleFiltrosChange = (filtros: FiltrosReclamos) => {
    setFiltros(filtros);
  };

  useEffect(() => {
    const url = new URL(window.location.toString());
    const params = new URLSearchParams(url.search);

    const nombre = params.get("nombre_ps");
    const codigo = params.get("codigo_ps");
    const fechaInicio = params.get("fecha_desde");
    const fechaFin = params.get("fecha_hasta");

    const ps = nombre && codigo ? { nombre, codigo } : undefined;

    setFiltros({
      puntoDeServicio: ps,
      fechaInicio: fechaInicio ? new Date(fechaInicio) : undefined,
      fechaFin: fechaFin ? new Date(fechaFin) : undefined,
    });
  }, []);

  return (
    <IonRouterOutlet>
      <Switch>
        <Route exact path="/reclamos/filtros">
          <ReclamosFiltros
            filtros={filtros}
            handleFiltrosChange={handleFiltrosChange}
          />
        </Route>

        <Route exact path="/reclamos">
          <Menu
            contentId="reclamos"
            cerrarSesion={props.cerrarSesion}
            user={props.user}
            cargo={props.cargo}
          />

          <ReclamosDeTrabajo cargo={props.cargo} filtros={filtros} />
        </Route>
      </Switch>
    </IonRouterOutlet>
  );
};

export default ReclamosConFiltro;
